import React from 'react'
import {Nav} from 'react-bootstrap';

const PlayerButton = (props) => {
    return (
        <Nav.Link onClick={props.onClick} className="playerButton">
            <img src={props.icon} alt="icon"/> {props.name}
        </Nav.Link>
    )
}
export default PlayerButton;
